/** Display copy & reward tiers for Invite & Earn (server is source of truth later). */

import { buildInviteLandingUrl } from "./referralInviteLandings";

export const REFERRAL_FRIEND_BONUS_PERCENT = 20;

/** Inviter cut of friend's first subscription credits, by plan. */
export const REFERRAL_INVITER_PERCENT_BY_PLAN = {
  free: 10,
  lite: 15,
  pro: 20,
  max: 25,
};

export const REFERRAL_PLAN_LABELS = {
  free: "Free",
  lite: "Lite",
  pro: "Pro",
  max: "Max",
};

export const REFERRAL_PAGE_SUBTITLE =
  "Invite a friend — they get +20% credits on their first plan, you earn 10–25% based on your plan.";

export const REFERRAL_SCOPE_NOTE = "Applies to subscriptions only — not credit packs.";

/** Short rule under the plan rate table. */
export const REFERRAL_RATE_EXPLAINER =
  "Your earn % follows your LazyStudio plan. Upgrade your plan to earn a higher rate.";

/** Concrete example for GTM clarity (credits on friend's first sub allotment). */
export const REFERRAL_EXAMPLE_COPY =
  "Example: friend buys a 100-credit plan → they get 120 credits; on Pro you earn 20."

export function getInviterPercent(planKey) {
  const key = String(planKey || "free").toLowerCase();
  return REFERRAL_INVITER_PERCENT_BY_PLAN[key] ?? REFERRAL_INVITER_PERCENT_BY_PLAN.free;
}

/** @param {string} code @param {string} [path] marketing path e.g. /tools/remove-background */
export function buildInviteUrl(code, path = "/") {
  return buildInviteLandingUrl(code, path);
}

export function buildInviteShareText(inviteUrl, toolBlurb = "LazyStudio") {
  const focus =
    toolBlurb && toolBlurb !== "LazyStudio"
      ? ` for ${toolBlurb}`
      : "";
  return `Join me on LazyStudio${focus} — edit product photos with AI. Use my invite for 20% extra credits on your first plan: ${inviteUrl}`;
}
